var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.303 12.667L1.333 15V2.667A.667.667 0 012 2h12a.667.667 0 01.667.667V12a.667.667 0 01-.667.667H4.303zm3.03-4V10h1.334V8.667H7.333zm0-4V8h1.334V4.667H7.333z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/feedback-icon.svg";
export { SvgFeedbackIcon as ReactComponent };